import { Component, HostListener, Input } from '@angular/core'
import { QuoteComponentService } from 'src/app/pages/quote/quote-component.service'
import { NavigationService } from 'src/app/service/navigation.service'

@Component({
  selector: 'quote-container-header',
  templateUrl: 'quote-container-header.component.html',
  styleUrls: ['quote-container-header.component.css'],
})
export class QuoteContainerHeader {
  @Input()
  vectorSrc: string = '/assets/external/vectori3387-9h9t.svg'
  @Input()
  vectorAlt: string = 'VectorI3387'
  @Input()
  vectorSrc1: string = '/assets/external/vectori3387-uxlr.svg'
  @Input()
  vectorAlt1: string = 'VectorI3387'
  @Input()
  vectorSrc2: string = '/assets/external/vectori3387-uzt9.svg'
  @Input()
  vectorAlt2: string = 'VectorI3387'
  @Input()
  vectorSrc3: string = '/assets/external/vectori3387-0vxl.svg'
  @Input()
  vectorAlt3: string = 'VectorI3387'
  @Input()
  vectorSrc4: string = '/assets/external/vectori3387-9bpv.svg'
  @Input()
  vectorAlt4: string = 'VectorI3387'
  @Input()
  vectorSrc5: string = '/assets/external/vectori3387-pxl.svg'
  @Input()
  vectorAlt5: string = 'VectorI3387'
  @Input()
  vectorSrc6: string = '/assets/external/vectori3387-wzo.svg'
  @Input()
  vectorAlt6: string = 'VectorI3387'
  @Input()
  vectorSrc7: string = '/assets/external/vectori3387-31th.svg'
  @Input()
  vectorAlt7: string = 'VectorI3387'
  @Input()
  vectorSrc8: string = '/assets/external/vectori3387-57xg.svg'
  @Input()
  vectorAlt8: string = 'VectorI3387'
  @Input()
  vectorSrc9: string = '/assets/external/vectori3387-3h2k.svg'
  @Input()
  vectorAlt9: string = 'VectorI3387'
  @Input()
  vectorSrc10: string = '/assets/external/vectori3387-wcy.svg'
  @Input()
  vectorAlt10: string = 'VectorI3387'
  @Input()
  rootClassName: string = ''
  raw3390: string = ' '
  isSticky: boolean = false;
  goBackText: string = "< Volver atrás"
  constructor(private navigate: NavigationService, public quoteService: QuoteComponentService) {}

  @HostListener('document:scroll', [])
  onWindowScroll() {
    const offset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  
    if (offset > 100) {
      this.isSticky = true;
    } else {
      this.isSticky = false;
    }
}
  goBack() {
		// En el primer paso no hay paso anterior: volver atras lleva al inicio del sitio
		if (this.quoteService.currentStep <= 1) {
			this.navigate.navigateToHome();
			return;
		}
		this.quoteService.prevStep()
	}
  goHome() {
		this.navigate.navigateToHome();
	}
}
